// import Vue from 'vue'
import Vuex from 'vuex'
import util from '../api/util'
Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		userMsg: {},
		langConfig: { options: [], name: '' },
		webSites: {},
		modules: {}
	},
	mutations: {
		getUsername(state, value) {
			state.userMsg = value;
		},
		getLanglist(state, value) {
			state.langConfig.options = value;
			value.map(element => {
				if (element.disabled) { state.langConfig.name = element.name }
			});
		},
		getWebsitelist(state, value) {
			state.webSites = value;
		},
		getModules(state,value) {
			state.modules = value;
		},
		clear(state) {
			state.userMsg = {};
			state.langConfig = { options: [], name: '' };
			state.webSites = {};
			state.modules = {};
		},
		changeLangName(state, value) {
			state.langConfig.name = value.name;
		}
	},
	getters: {

	}
})

export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js